import type { TAccount } from "@/schemas/user.schema"

export type AccountTrialStatus = "notInTrial" | "trialExpired" | "inTrial"

type AccountTrialStateInput = Pick<TAccount, "trialActivated" | "inTrial" | "trialExpired" | "isSoloFree" | "soloTrialConsumed">

export function isAccountTeamTrialExpired(account: Pick<AccountTrialStateInput, "inTrial" | "trialExpired">) {
  return Boolean(account.inTrial && account.trialExpired)
}

export function getAccountTrialStatus(account: AccountTrialStateInput): AccountTrialStatus {
  if (!account.trialActivated) return "notInTrial"

  if (account.inTrial) {
    return isAccountTeamTrialExpired(account) ? "trialExpired" : "inTrial"
  }

  if (account.isSoloFree) {
    return account.soloTrialConsumed ? "trialExpired" : "inTrial"
  }

  return "notInTrial"
}
